import { render } from "./AdminReferidAllUsers.vue?vue&type=template&id=b623a09a"
import script from "./AdminReferidAllUsers.vue?vue&type=script&lang=js"
export * from "./AdminReferidAllUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__